import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import Modal from './Modal';
import { BorderGrey, White } from '../../constants/Colors';
import DefaultStyles from '../../constants/DefaultFormStyles';

const StyledModal = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const StyledEditorWrapper = styled.div`
  flex: 1;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 12px;
  background-color: ${White};
  border-radius: ${DefaultStyles.borderRadius};

  .rdw-option-wrapper {
    width: 30px;
    height: 30px;
    border-radius: 5px;
    border: 1px solid ${BorderGrey};
  }

  .rdw-dropdown-wrapper {
    height: 40px;
    border-radius: 5px;
    border: 1px solid ${BorderGrey};
  }

  .rte-field-wrapper-class {
    width: 100%;
    height: 100%;
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: ${DefaultStyles.borderRadius};
  }

  .rte-field-toolbar-class {
    border-radius: 5px;
    border: 1px solid ${BorderGrey};
  }

  .rte-field-editor-class {
    height: 100%;
    width: 100%;
    border-radius: 5px;
    border: 1px solid ${BorderGrey};
  }

  .rdw-colorpicker-modal-options {
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .rdw-editor-wrapper {
    .rdw-editor-main {
      line-height: 1.2;
      overflow: auto;
      min-height: 200px;
      max-height: 200px;

      .public-DraftStyleDefault-block {
        margin: 0px;
      }
    }
  }

`;

class RTEEditorModal extends PureComponent {

  static propTypes = {
    id: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string
    ]),
    display: PropTypes.bool,
    onHide: PropTypes.func,
    onSubmit: PropTypes.func,
  }

  constructor(props) {
    super(props);
    this.state = {
      contentState: {} // ContentState JSON
    };
  }

  render() {

    const { value, id, display, onHide } = this.props;

    if (!display) return null;

    const editorOptions = { };
    if (value) editorOptions.initialContentState = typeof value === 'object' ? value : JSON.parse(value);

    return (
      <Modal
        isOpen={display}
        height={380}
        onHide={onHide}
        title="Editor"
        cancelText="Cancel"
        onCancel={onHide}
        submitText="Save"
        onSubmit={this.handleSubmit}
      >
        <StyledModal>
          <StyledEditorWrapper>
            <Editor
              {...editorOptions}
              placeholder="Type to add text"
              toolbarClassName="rte-field-toolbar-class"
              wrapperClassName="rte-field-wrapper-class"
              editorClassName="rte-field-editor-class"
              onContentStateChange={this.handleContentStateChange}
              testid={`${id}-rte-editor-modal`}
              onBlur={this.handleChange}
              toolbar={{
                options: ['inline', 'fontSize', 'textAlign'],
                inline: {
                  options: ['bold', 'italic', 'underline']
                },
                fontSize: {
                  options: [4, 6, 8, 10, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
                },
                textAlign: {
                  inDropdown: true,
                  options: ['left', 'center', 'right']
                }
              }}
            />
          </StyledEditorWrapper>
        </StyledModal>
      </Modal>
    );

  }

  handleContentStateChange = (contentState) => {
    this.setState({ contentState });
  }

  handleSubmit = () => {

    const { onSubmit } = this.props;
    const { contentState } = this.state;

    if (onSubmit) onSubmit(contentState);

  }

}

export default RTEEditorModal;
